<template>
  <div>
    <h2 class="text-2xl font-bold select-none">{{ title }}</h2>
    <p class="text-gray-400 mt-2 mb-6 select-none">{{ subtitle }}</p>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    required: true
  }
});
</script>
